import React from 'react';

import { Box, Flex } from '@chakra-ui/react';
import { uniqBy } from 'lodash';
import { useDispatch } from 'react-redux';
import {
  setAgendaLibraryThemeType,
  useOneOnOneAgendaLibraryThemeType,
  useOneOnOneAgendaLibraryType,
  useOneOnOneAgendaLibraryLifeCycleMomentType,
  setAgendaLibraryLifeCycleMomentType,
} from 'screens/oneOnOneRabbit/InstancePage/slice/OneOnOneInstancePageSlice';

import { ListItemComp } from 'uiToolkitV1/ListItemComp';

import { AGENDA_THEME_TYPE, LIFECYCLE_MOMENT_TYPE, OneOnOneAgendaLibraryI } from '../interface';
import { AgendaLibraryAgGrid } from './AgendaLibraryAgGrid';

interface Props {
  data: OneOnOneAgendaLibraryI;
  isLoading: boolean;
  isSettingsPage?: boolean;
  onAgendaClick?: ({ id, agendaText }: { id: number; agendaText: string }) => void;
}

type AgendaLibraryMapType<K extends typeof AGENDA_THEME_TYPE> = Record<K[number], string>;

const AGENDA_THEME_TYPE_MAP: AgendaLibraryMapType<typeof AGENDA_THEME_TYPE> = {
  BELONGING: 'Belonging and well-being',
  COLLABORATION: 'Collaboration',
  GROWTH: 'Growth and development',
  PERFORMANCE: 'Performance',
  MANAGER_EFFECTIVENESS: 'Manager effectiveness',
};

const AgendaLibraryBody = ({ data, isLoading, isSettingsPage, onAgendaClick }: Props) => {
  const dispatch = useDispatch();
  // const agendaLibraryTypeOptions = Object.keys(AGENDA_THEME_TYPE_MAP);
  const selectedType = useOneOnOneAgendaLibraryType();

  const selectedThemeType = useOneOnOneAgendaLibraryThemeType();

  const selectedLifeCycleMomentType = useOneOnOneAgendaLibraryLifeCycleMomentType();

  const agendaLibraryTypeOptions =
    uniqBy(
      data?.map((item) => ({
        theme: item.theme,
        themeDisplayText: item.themeDisplayText,
      })),
      'theme'
    ) || [];

  const agendaLibraryLifeCycleMomentOptions =
    uniqBy(
      data?.map((item) => ({
        lifeCycleMoment: item.lifecycleMoment,
        lifeCycleMomentDisplayText: item.lifecycleMomentDisplayText,
      })),
      'lifeCycleMoment'
    ) || [];

  const onThemeTypeClick = (themeType: keyof typeof AGENDA_THEME_TYPE_MAP) => {
    dispatch(
      setAgendaLibraryThemeType({
        themeType,
      })
    );
  };

  const onLifeCycleMomentTypeClick = (lifeCycleMomentType: (typeof LIFECYCLE_MOMENT_TYPE)[number]) => {
    dispatch(
      setAgendaLibraryLifeCycleMomentType({
        lifeCycleMomentType,
      })
    );
  };

  return (
    <Flex p="4px" bg="#EBEFF3" h="100%" w="100%" borderRadius="8px 8px 0px 0px">
      <Box overflow="auto" w="240px" h="100%" bg="white" borderRadius="8px" p="8px">
        {/* <Box p="8px 12px 12px" borderBottom={'1px solid #CFD7DF'}>
          <TextLabel bold>Topics</TextLabel>
        </Box> */}
        <Box
          sx={{
            div: {
              margin: '0px !important',
            },
            '.active-styles p': {
              color: '#333333 !important',
            },
          }}
          mt="4px"
        >
          {selectedType === 'THEME' && (
            <>
              {agendaLibraryTypeOptions.map((option, index) => (
                // @ts-ignore
                <ListItemComp
                  key={`agenda-${index}`}
                  // title={AGENDA_THEME_TYPE_MAP[option]}
                  title={option.themeDisplayText}
                  isBoldText={false}
                  padding="12px"
                  active={selectedThemeType === option.theme}
                  onClick={() => onThemeTypeClick(option.theme as keyof typeof AGENDA_THEME_TYPE_MAP)}
                  className="agenda-library-list-item"
                />
              ))}
            </>
          )}
          {selectedType === 'LIFECYCLE_MOMENT' && (
            <>
              {agendaLibraryLifeCycleMomentOptions.map((option, index) => (
                // @ts-ignore
                <ListItemComp
                  key={`agenda-lifecycle-${index}`}
                  // title={AGENDA_THEME_TYPE_MAP[option]}
                  title={option.lifeCycleMomentDisplayText}
                  isBoldText={false}
                  padding="12px"
                  active={selectedLifeCycleMomentType === option.lifeCycleMoment}
                  onClick={() => onLifeCycleMomentTypeClick(option.lifeCycleMoment)}
                  className="agenda-library-list-item"
                />
              ))}
            </>
          )}
        </Box>
      </Box>
      <Box ml="4px" w="100%" bg="white" borderRadius="8px" p="4px">
        <AgendaLibraryAgGrid
          data={data}
          isLoading={isLoading}
          isSettingsPage={isSettingsPage}
          onAgendaClick={onAgendaClick}
        />
      </Box>
    </Flex>
  );
};

export { AgendaLibraryBody };
